<template>
  <div class="edit-dialog" @contextmenu.stop>
    <el-dialog
      title="批量修改专有词库"
      width="450px"
      height="335px"
      top="calc( 50vh - 150px )"
      custom-class="edit-share"
      center
      :visible.sync="visible"
      :close-on-click-modal="false"
      :append-to-body="true"
      :handleCancel="handleCancel"
    >
      <div class="setting-container">
        <div class="button-group">
          <el-button @click="downloadExcel">导出专有词库</el-button>
          <label class="uploading" for="uploadExcel">上传专有词库</label>
          <input type="file" id="uploadExcel" ref="uploadExcel" @change="addFile($event)" accept=".xlsx,.xls" style="display: none" />
        </div>
        <div class="file-name">
          <span>{{ excelFileName }}</span>
          <img class="select-del" src="@imgs/delete-gray.png" @click="delFile()" />
        </div>
        <div class="tips">
          <p>批量修改方法：</p>
          <p>1、导出专有词库，下载Excel文件；</p>
          <p>2、编辑词库Excel文件；</p>
          <p>3、上传修改后的Excel文件；</p>
          <p>4、点击“修改词库”解析后即可完成专有词库的更新。</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="left" @click="handleCancel()">取消</el-button>
        <el-button type="primary" @click="save()">修改词库</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from '@api/specialWord'
export default {
  name: 'BatchEditDialog',
  data() {
    return {
      visible: false,
      excelFileName: '',
      fileData: null
    }
  },
  props: {
    libId: {
      default: ''
    }
  },
  computed: {},
  methods: {
    handleCancel() {
      this.visible = false
    },
    addFile(e) {
      this.fileData = e.target.files[0]
      if (this.fileData) {
        this.excelFileName = this.fileData.name
      }
    },
    delFile() {
      this.excelFileName = ''
      this.fileData = null
      this.$refs.uploadExcel.value = ''
    },
    downloadExcel() {
      let a = document.createElement('a')
      a.href = `${window.PROJECT_CONFIG.BASE_URL}/ebook/specificWordLib/exportSpecificWordLib?id=${this.libId}`
      console.log(a.href)
      a.target = '_blank'
      a.click()
    },
    save() {
      if (!this.fileData) {
        this.$message.error('请上传文件')
        return
      }
      let params = new FormData()
      params.append('id', this.libId)
      params.append('dataFile', this.fileData)
      api.importSpecificWordLib(params).then((res) => {
        if (res.status === 200 && res.data.status === 0) {
          this.$message.success(res.data.message || '修改成功')
          this.fileData = null
          this.excelFileName = ''
          this.visible = false
          this.$emit('saveSuccess')
        } else {
          this.$message.error(res.data.message || '修改失败')
        }
      })
    }
  },
  mounted() {}
}
</script>
<style lang="scss" scoped>
.setting-container {
  .button-group {
    padding: 0 40px;
    .uploading {
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      background: #ffffff;
      border: 1px solid #dcdfe6;
      color: #606266;
      -webkit-appearance: none;
      text-align: center;
      box-sizing: border-box;
      padding: 12px 20px;
      font-size: 14px;
      border-radius: 4px;
      margin-left: 50px;
      margin-top: 2px;
      &:hover {
        color: #df5813;
        border-color: #f5cdb8;
        background-color: #fceee7;
      }
    }
  }
  .file-name {
    text-align: right;
    margin-top: 10px;
    padding-right: 45px;
    img {
      width: 20px;
      margin-left: 30px;
    }
  }
  .tips {
    font-size: 12px;
    color: #808080;
  }
}
.dialog-footer {
  .el-button {
    &:first-child {
      background: #909399;
      color: #fff;
      border: 1px solid #909399;
    }
  }
}
</style>
